// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wl_a bib_b"};